import React from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip, Dropdown } from 'react-bootstrap';
import ElementDownload from '../../icons/element-download.svg';
import ToggleButton from './ToggleButton';
import './styles.scss';

function DownloadAs({ onDownloadClick, id, actionComponent }) {
    return (
        <Dropdown>
            <Dropdown.Toggle as={ToggleButton} id="dropdown-basic">
                <OverlayTrigger
                    trigger={'hover'}
                    placement={'right'}
                    overlay={
                        <Tooltip id={id} className="download-tooltip">
                            {'Click to Download as Image'}
                        </Tooltip>
                    }
                >
                    {actionComponent ? (
                        actionComponent
                    ) : (
                        <img src={ElementDownload} className="download-as" />
                    )}
                </OverlayTrigger>
            </Dropdown.Toggle>

            <Dropdown.Menu>
                <Dropdown.Item onClick={() => onDownloadClick('jpeg')}>
                    JPEG
                </Dropdown.Item>
                <Dropdown.Item onClick={() => onDownloadClick('png')}>
                    PNG
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );
}

DownloadAs.propTypes = {
    onDownloadClick: PropTypes.func.isRequired,
    id: PropTypes.string,
    actionComponent: PropTypes.node,
};

DownloadAs.defaultProps = {
    id: '',
    actionComponent: null,
};

export default DownloadAs;
